<template>
  <DashboardCard :border="false" :firstContent="true">
    <template #content>
      <h4 class="mb-0 font-20px">{{ $t("widgets.dealerPerformance.title") }}</h4>
    </template>
    <template #table>
      <MDBTable borderless class="table-dashboard pt-2">
        <tbody>
          <tr>
            <td>{{ $t("widgets.dealerPerformance.performanceAnnualEngagement") }}</td>
            <td>{{ normalizedAnnualEngagement }}</td>
          </tr>
          <tr>
            <td>{{ $t("widgets.dealerPerformance.performanceVolumeToDate") }}</td>
            <td>{{ normalizedVolumeToDate }}</td>
          </tr>
          <tr v-if="showBoosterCcsParticipant">
            <td>{{ $t("widgets.dealerPerformance.boosterCcsParticipant") }}</td>
            <td>{{ boosterLabel }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </template>
  </DashboardCard>
</template>

<script setup>
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  data: { type: Object, required: true },
});

const normalizedAnnualEngagement = computed(
  () => props.data?.performance_annual_engagement ?? 0
);
const normalizedVolumeToDate = computed(
  () => props.data?.performance_volume_to_date ?? 0
);
const showBoosterCcsParticipant = computed(
  () => Boolean(props.data?.booster_ccs_participant)
);
const boosterLabel = computed(() => t("account.profile.yes"));
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";

.font-20px {
  font-size: 20px;
}
</style>
